module.exports = __webpack_public_path__ + "static/6-5f2490cfaa60e82a86335f52bbd8f5b4.jpeg";